import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import HeaderPanel from './../../HeaderPanel';
import FooterPanel from './../../FooterPanel';
import MembershipHeroPanel from "./MembershipHeroPanel";
import MembershipBuyPanel from "./MembershipBuyPanel";
import MerchPanel from "./../../MerchPanel";

const useStyles = theme => ({
    branding: {
        display: 'flex',
        flexWrap: 'wrap',
    },
});

class MembershipPage extends React.Component {
  myRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    let self = this;
  }

  componentWillUnmount() {
  }

  render() {
    const { classes } = this.props;

    let self = this;

      return (
          <div className={classes.branding}>
              <HeaderPanel showLogo={true} ref={this.myRef} page={'classes'} />
              <MembershipHeroPanel />
              <MembershipBuyPanel />
              <MerchPanel />
              <FooterPanel />
          </div>
      );
  }
}

export default withStyles(useStyles)(MembershipPage)
